import { Avatar, Card, List, ListItem, Stack, Typography } from "@mui/material";
import sampleProfileImage from "assets/images/sample.png";
import { useEffect, useRef, useState } from "react";

const TagUserPopover = ({ handleUserClick, filteredUsers, isMobileDisplay, handleClose }) => {
  const [focusedIndex, setFocusedIndex] = useState(0);
  const focusedIndexRef = useRef(0);

  const handleKeyDown = (event) => {
    event.stopPropagation();

    if (event.key === "Enter") {
      handleUserClick(filteredUsers[focusedIndexRef.current]);
    } else if (event.key === "ArrowDown") {
      event.preventDefault();
      const nextIndex =
        focusedIndexRef.current < filteredUsers.length - 1 ? focusedIndexRef.current + 1 : 0;
      focusedIndexRef.current = nextIndex;
      setFocusedIndex(nextIndex);
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      const prevIndex =
        focusedIndexRef.current > 0 ? focusedIndexRef.current - 1 : filteredUsers.length - 1;
      focusedIndexRef.current = prevIndex;
      setFocusedIndex(prevIndex);
    } else if (event.key === "ArrowLeft") {
      event.preventDefault();
    } else if (event.key === "ArrowRight") {
      event.preventDefault();
    } else if (event.key === "Escape") {
      handleClose();
    }
  };

  useEffect(() => {
    setFocusedIndex(0);
    focusedIndexRef.current = 0;
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [filteredUsers]);

  return (
    <Card
      sx={{
        p: "0.5rem 0",
        maxHeight: "350px",
        maxWidth: "400px",
        minWidth: isMobileDisplay ? "350px" : "450px",
        backgroundColor: "#28282a",
        display: "flex",
        border: "1px solid #393939",
        overflow: "auto",
      }}
    >
      <List>
        {filteredUsers.map((user, index) => (
          <ListItem
            className="tag-user-list-item"
            button
            key={user.id}
            onClick={() => handleUserClick(user)}
            sx={{
              padding: "0.25rem 0.75rem",
              color: "#ddd9d5",
              "&:hover": { cursor: "pointer", backgroundColor: "#2f2f31" },
              justifyContent: "space-between",
              display: "flex",
              backgroundColor: index === focusedIndex ? "rgba(74, 74, 117, 0.5)" : "transparent",
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Avatar
                variant="circular"
                alt={user.name.toUpperCase()}
                src={user.profile_picture || sampleProfileImage}
                sx={{ width: "30px", height: "30px" }}
              />
              <Typography sx={{ fontSize: "1rem" }}>{user.name}</Typography>
            </Stack>
            <Typography sx={{ fontSize: "0.85rem", color: "#888" }}>{user.user.email}</Typography>
          </ListItem>
        ))}
      </List>
    </Card>
  );
};

export default TagUserPopover;
